import React from 'react';
import { CategoryTournamentTitle } from '../Favorites/CategoryTournamentTitle';
import { LevelProps } from './types';

export const TreeCategory: React.FC<LevelProps> = props => {
    const { id, tree, } = props;
    const tournament = tree.t[id];
    const fixtureWithMarkets = tree.f;
    let hasFixtures = tournament.cl ||  tournament.f.some(fixtureId => fixtureWithMarkets.indexOf(fixtureId) > -1);
    if (!hasFixtures) {
        return <></>
    }
    return (
        <CategoryTournamentTitle
            categoryName={tournament.cn}
            tournamentName={tournament.tn}
            categoryImageUrl={tournament.ciu}
        />
    )
};